import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output, Renderer2, Input } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { unsubscribe } from '@fcom/utils';

@Directive({
  selector: '[finClickOutside]',
})
export class ClickOutsideDirective implements AfterViewInit, OnDestroy {
  @Input() clickOutsideException = '';

  @Output()
  finClickOutside: EventEmitter<Event> = new EventEmitter();

  private subscription: Subscription;
  private timeout: any;
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    // setTimeout needed for the event not to occur when click inserts this directive in DOM
    this.timeout = setTimeout(() => {
      const globalClicks$ = new Observable<Event>((observer) =>
        this.renderer.listen('document', 'click', (event: Event) => observer.next(event))
      );
      this.subscription = globalClicks$
        .pipe(
          filter(
            (event: Event) => !this.elementRef.nativeElement.contains(event.target) && !this.exceptionInPath(event)
          )
        )
        .subscribe((event) => this.finClickOutside.emit(event));
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeout);
    unsubscribe(this.subscription);
  }

  private exceptionInPath(event: Event): boolean {
    if (this.clickOutsideException === '') {
      return false; // don't even check if input is not given
    }
    if (!event.composedPath) {
      return true; // native clicks have this but test suite clicks don't
    }
    return event.composedPath().find((pathElem: Element) => pathElem.localName === this.clickOutsideException)
      ? true
      : false;
  }
}
